import { Phone, PhoneOff, Video } from 'lucide-react';
import type { IncomingCall } from '../services/callApi';

type IncomingCallOverlayProps = {
  incoming: IncomingCall | null;
  isBusy: boolean;
  onAccept: () => void;
  onReject: () => void;
};

export function IncomingCallOverlay({ incoming, isBusy, onAccept, onReject }: IncomingCallOverlayProps) {
  if (!incoming) {
    return null;
  }

  const Icon = incoming.mode === 'video' ? Video : Phone;

  return (
    <div className="overlay incoming-overlay" role="dialog" aria-modal="true" aria-labelledby="incoming-call-title">
      <div className="confirm-sheet incoming-sheet">
        <span className="permission-icon danger call-ring-icon">
          <Icon size={28} aria-hidden="true" />
        </span>
        <div>
          <p className="panel-kicker">Incoming {incoming.mode} call</p>
          <h2 id="incoming-call-title">{incoming.caller} is calling</h2>
          <p>This feature works best when both users have the app open. Call quality depends on internet connection.</p>
        </div>
        <div className="confirm-actions">
          <button className="secondary-button" type="button" onClick={onReject} disabled={isBusy}>
            <PhoneOff size={18} aria-hidden="true" />
            Reject
          </button>
          <button className="danger-button" type="button" onClick={onAccept} disabled={isBusy}>
            <Phone size={18} aria-hidden="true" />
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
